import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/checkout';

/**
 * Sticky bottom bar that appears once the user has scrolled past the first
 * hero CTA (element with id="hero-cta").
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const update = () => {
      const rect = anchor.getBoundingClientRect();
      setVisible(rect.bottom < 8);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-accent/25 bg-ink-950/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur transition-[transform,opacity] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-31" data-mp="19787a85r2jfu">
      <div className="mx-auto flex max-w-xl items-center gap-3" data-id="element-32" data-mp="2f398pcvl5m5p">
        <div className="hidden shrink-0 sm:block" data-id="element-33" data-mp="21bkwl9lc6xoq">
          <p className="font-display text-lg leading-none text-white" data-id="element-34" data-mp="21at6geaids5u">19 €</p>
          <p className="text-[10px] font-semibold uppercase tracking-wider text-white/45" data-id="element-35" data-mp="269w0z4sv4fzk">
            invece di 677 €
          </p>
        </div>
        <a href={CHECKOUT_URL} className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-accent px-4 py-3.5 font-display text-[13px] uppercase leading-tight tracking-wide text-ink-950 shadow-[0_10px_30px_-10px_rgba(255,193,7,0.7)] animate-shake transition-colors duration-150 ease-out hover:bg-accent-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent sm:text-sm" data-id="element-36" data-mp="1we2jr8477ybg">
          <ZapIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-37" data-mp="3hoje1v0u6yk8" />
          Voglio il Sistema per 19 €
        </a>
      </div>
    </div>;
}